module.exports = __webpack_public_path__ + "static/img/background.59eccd83.svg";